<template>
    <div v-if="hospitalDesc || clinicDesc" class="msu" :class="{ 'is-muted': !status }">
        <div class="msu-title">
            Coverage Access
        </div>

        <div v-if="hospitalDesc" class="msu-row">
            <v-icon class="msu-icon" size="22">
                {{ mdiHospitalBuilding }}
            </v-icon>
            <div class="msu-text">
                <div class="msu-label">
                    Hospital Access
                </div>
                <div class="msu-desc">
                    {{ hospitalDesc }}
                </div>
            </div>
            <span v-if="hospitalCode" class="msu-code">{{ hospitalCode }}</span>
        </div>

        <div v-if="clinicDesc" class="msu-row">
            <v-icon class="msu-icon" size="22">
                {{ mdiStethoscope }}
            </v-icon>
            <div class="msu-text">
                <div class="msu-label">
                    Clinic Access
                </div>
                <div class="msu-desc">
                    {{ clinicDesc }}
                </div>
            </div>
            <span v-if="clinicCode" class="msu-code">{{ clinicCode }}</span>
        </div>
    </div>
</template>

<script>
import { mdiHospitalBuilding, mdiStethoscope } from '@mdi/js'

/**
 * Hospital / clinic access (MSU) of a member.
 *
 * Usage:
 *   <MsuAccess
 *       :hospital-code="member.HOSP_MSU"
 *       :hospital-desc="member.HOSP_MSU_DESC"
 *       :clinic-code="member.CLIN_MSU"
 *       :clinic-desc="member.CLIN_MSU_DESC"
 *       :status="isActive"
 *   />
 *
 * Renders nothing when both descriptions are empty.
 */
export default {
    name: 'MsuAccess',
    props: {
        hospitalCode: { type: String, default: '' },
        hospitalDesc: { type: String, default: '' },
        clinicCode: { type: String, default: '' },
        clinicDesc: { type: String, default: '' },
        // false = muted look for members who are not active
        status: { type: Boolean, default: true }
    },
    data: () => ({
        mdiHospitalBuilding,
        mdiStethoscope
    })
}
</script>

<style scoped>
.msu {
  padding: 16px 28px 8px;
}
.msu-title {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #00796b;
}
.msu-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, .08);
}
.msu-row:last-child {
  border-bottom: 0;
}
.msu-icon {
  flex: 0 0 auto;
  color: #00796b !important;
}
.msu-text {
  flex: 1 1 auto;
  min-width: 0; /* lets long descriptions wrap */
}
.msu-label {
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, .6);
}
.msu-desc {
  margin-top: 2px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
.msu-code {
  flex: 0 0 auto;
  padding: 2px 10px;
  border-radius: 99px;
  background: #e0f2f1;
  color: #00695c;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .5px;
}

/* "WITHOUT ACCESS" rows */
.msu-row.is-denied .msu-icon { color: #b26a00 !important; }
.msu-row.is-denied .msu-desc { color: #b26a00; }
.msu-row.is-denied .msu-code { background: #fff3e0; color: #b26a00; }

/* not active: everything gray */
.msu.is-muted .msu-title,
.msu.is-muted .msu-icon,
.msu.is-muted .msu-desc { color: #777 !important; }
.msu.is-muted .msu-code { background: #eee; color: #777; }

@media (max-width: 599px) {
  .msu { padding: 14px 16px 6px; }
}
</style>
